import moment from 'moment';
import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getGuests } from '../../actions/auth';

const AdminGuestMain = ({ getGuests, auth, guest: {guests} }) => {

    useEffect(() => {
        getGuests();
      }, [getGuests])

  return (
    <div className='container'>
        <h4><i className='fa-light fa-receipt' style={{color: 'var(--primary-color)'}} />&nbsp;All Guests</h4>
        {guests.map((g) => (
            <div className='bs container' style={{ maxWidth: '90%'}} key={g._id}>
            <Row>
                <Col style={{padding: '10px'}}>
                    <h6>Guest Details</h6>
                    <Row><Col>Name</Col><Col>{g.name}</Col></Row>
                    <Row><Col>Email</Col><Col>{g.email}</Col></Row>
                    <Row><Col>Date Registered</Col><Col>{moment(g.date).format('DD MMM YYYY')}</Col></Row>
                </Col>
            </Row>
        </div>
      ))}
    </div>
  )
}

AdminGuestMain.propTypes = {
    guest: propTypes.object.isRequired,
    auth: propTypes.object.isRequired,
    getGuests: propTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    guest: state.guest
})

export default connect(mapStateToProps, {getGuests})(AdminGuestMain);